import { Route } from "react-router-dom";
import { ProtectedRoute } from "./routes/ProtectedRoute.jsx";
import { ROLES } from "@/config/roles.js";
import i18n from "@/i18n.js";

import TemplateAdmin from "@/layout/TemplateAdmin.jsx";
import UsersInternal from "@/pages/admin/UsersInternal.jsx";
import ImpersonateUser from "@/pages/admin/ImpersonateUser.jsx";
import UsersCompanies from "@/pages/shared/UsersCompanies.jsx";
import Companies from "@/pages/contador/Companies/Companies.jsx";
import DetailCompany from "@/pages/contador/Companies/DetailCompany.jsx";
import FoliosHome from "@/pages/contador/Folios/FoliosHome.jsx";
import ShowTicket from "@/pages/contador/Folios/ShowTicket.jsx";
import BillsAdmin from "@/pages/contador/Bills/BillsAdmin.jsx";
import ShowBillAdmin from "@/pages/contador/Bills/ShowBillAdmin.jsx";
import ContactsAdmin from "@/pages/contador/Contacts/ContactsAdmin.jsx";
import ClientUsers from "@/pages/contador/ClientUsers/ClientUsers.jsx";
import ClientUserDetail from "@/pages/contador/ClientUsers/ClientUserDetail.jsx";
import NotificationsAdmin from "@/pages/contador/Settings/NotificationsAdmin.jsx";
import EmailLogViewer from "@/pages/contador/Settings/EmailLogViewer.jsx";
import PackagesAdmin from "@/pages/contador/Settings/PackagesAdmin.jsx";
import McpAdmin from "@/pages/contador/Settings/Mcp/McpAdmin.jsx";

const AdminRoutes = (
  <Route
    element={<ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER_ADMIN]} />}
  >
    <Route element={<ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN]} />}>
      <Route
        path="/users-internal"
        element={
          <TemplateAdmin
            path="/users-internal"
            title={"Usuarios Internos"}
            content={<UsersInternal />}
          />
        }
      />
      <Route
        path="/impersonate"
        element={
          <TemplateAdmin
            path="/impersonate"
            title={"Suplantar usuario"}
            content={<ImpersonateUser />}
          />
        }
      />
      <Route
        path="/settings/notifications"
        element={
          <TemplateAdmin
            path="/settings/notifications"
            title={"Configuraciones · Notificaciones"}
            content={<NotificationsAdmin />}
          />
        }
      />
      <Route
        path="/settings/emails"
        element={
          <TemplateAdmin
            path="/settings/emails"
            title={"Configuraciones · Correos enviados"}
            content={<EmailLogViewer />}
          />
        }
      />
      <Route
        path="/settings/packages"
        element={
          <TemplateAdmin
            path="/settings/packages"
            title={"Configuraciones · Paquetes"}
            content={<PackagesAdmin />}
          />
        }
      />
    </Route>
    {/* El MCP lo configura cualquier contador, no sólo el jefe: es su propia
        llave la que emite y con sus permisos entra. */}
    <Route
      path="/settings/mcp"
      element={
        <TemplateAdmin
          path="/settings/mcp"
          title={"Configuraciones · MCP"}
          content={<McpAdmin />}
        />
      }
    />
    <Route
      path="/companies"
      element={<TemplateAdmin
          title={i18n.t("page.issuers")}
          content={<Companies />}
        />}
    />
    <Route
      path="/contacts-admin"
      element={
        <TemplateAdmin
          title={i18n.t("page.receivers")}
          content={<ContactsAdmin />}
        />
      }
    />
    <Route
      path="/client-users"
      element={
        <TemplateAdmin title={"Usuarios (clientes)"} content={<ClientUsers />} />
      }
    />
    <Route
      path="/client-users/:userId/show"
      element={
        <TemplateAdmin
          title={"Detalle del usuario"}
          content={<ClientUserDetail />}
        />
      }
    />
    <Route
      path="/:id/detailCompany"
      element={
        <TemplateAdmin
          title={i18n.t("page.issuerData")}
          content={<DetailCompany />}
        />
      }
    />
    <Route
      path="/users-companies"
      element={
        <TemplateAdmin
          path="/users-companies"
          title={i18n.t("page.issuerList")}
          content={<UsersCompanies />}
        />
      }
    />
    <Route
      path="/folios"
      element={
        <TemplateAdmin
          path="/folios"
          title={"Administrador de Folios"}
          content={<FoliosHome />}
        />
      }
    />
    <Route
      path={"/folios/:requestTicketId/show"}
      element={
        <TemplateAdmin
          title={"Detalle de paquetes solicitado"}
          content={<ShowTicket />}
        />
      }
    />
    <Route
      path="/billsAdmin"
      element={
        <TemplateAdmin
          path="/folios"
          title={"Administrador de Facturas"}
          content={<BillsAdmin />}
        />
      }
    />
    <Route
      path="/billsAdmin/:billingId/show"
      element={
        <TemplateAdmin
          path="/folios"
          title={"Administrador de facturas"}
          content={<ShowBillAdmin />}
        />
      }
    />
  </Route>
);

export default AdminRoutes;
